import { Component } from '@angular/core';

@Component({
  selector: 'app-hero-terapia-fisica',
  standalone: true,
  imports: [],
  templateUrl: '../../movi-link/hero-pages/hero-movi-link.component.html',
  styleUrl: './hero-terapia-fisica.component.css'
})
export class HeroTerapiaFisicaComponent {
  title = 'Terapia Física';
  subtitle1 = 'Vive sin';
  subtitle2 = 'limitaciones';
  callToAction = 'Escríbenos';
  routeImageMain = 'assets/img/terapiaFisica/terapiaFisica.svg';

}
